<template>
    <article class="dd-m-card dd-m-card--category-product dd-m-card--category-product-custom">
		xxxxxxx1
        <a class="dd-m-card--category-product__link"
           @click.prevent="showOfflineProduct"
           :title="item.name">
            <div class="dd-m-card--category-product__thumb" v-if="item.image">
                <picture class="dd-m-card--category-product__img">
                    <source :srcset="item.image.desktop" media="(min-width: 1280px)">
                    <source :srcset="item.image.tablet" media="(min-width: 768px)">
                    <img :srcset="item.image.mobile" :alt="item.name">
                </picture>
            </div>

            <div class="dd-m-card--category-product__content">
                <h3 class="dd-m-card--category-product__title">
                    {{item.name}}
                </h3>

                <div class="dd-m-card--category-product__rating">
                    <span class="dd-m-icon icon-star"
                          v-bind:class="{'dd-m-text--deactive' : i >= item.rating}"
                          v-for="(i, index) in ratings"
                          :key="index"></span>
                </div>

                <div class="dd-m-card--category-product__reviews" v-if="item.reviews">
                    {{item.reviews}} reviews
                </div>

                <h4 class="dd-m-card--category-product__price"></h4>
            </div>
        </a>
    </article>
</template>
<script>
    export default {
        name: 'card-custom-category-product-offline',
        props: ['item'],
        data: () => {
            return {
                ratings: []
            }
        },
        mounted() {
            this.buildRatingArr();
        },
        methods: {
            buildRatingArr() {
                this.item.rating = parseFloat(this.item.rating);
                this.ratings = [];

                for (let i = 0; i < 5; i++) {
                    this.ratings.push(i);
                }
            },
            showOfflineProduct() {
                PubSub.publish('showOfflineProduct', this.item);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/products/card-custom-category-product-offline.vue